import React from 'react';
import { PeakFormEditor } from './PeakFormEditor';
import type { PeakFormEditorProps } from './PeakFormEditor';
import type { 
  FormDefinition, 
  Field, 
  Group, 
  EditorState,
  EditorAction,
  FieldType,
  InputControl,
  FieldValidation,
  DataSourceItem,
  ModifierType,
  ConditionOperator,
  Condition,
  Modifier,
  ParameterConfiguration
} from './types';

// Export the main component
export { PeakFormEditor };

// Export all types
export type { 
  PeakFormEditorProps,
  FormDefinition, 
  Field, 
  Group, 
  EditorState,
  EditorAction,
  FieldType,
  InputControl,
  FieldValidation,
  DataSourceItem,
  ModifierType,
  ConditionOperator,
  Condition,
  Modifier,
  ParameterConfiguration
};

// Export enums
export { 
  FieldType,
  InputControl,
  ModifierType,
  ConditionOperator
};

// Default form definition for examples
export const DEFAULT_FORM_DEFINITION: FormDefinition = {
  id: 'example-form',
  name: 'Example Form',
  version: '1.0.0',
  fields: [
    {
      id: 'name',
      type: FieldType.STRING,
      label: 'Full Name',
      inputControl: InputControl.TEXT,
      validation: { required: true },
      placeholder: 'Enter your full name'
    },
    {
      id: 'email',
      type: FieldType.STRING,
      label: 'Email Address',
      inputControl: InputControl.TEXT,
      validation: { 
        required: true,
        pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$',
        customMessage: 'Please enter a valid email address'
      },
      placeholder: 'email@example.com'
    },
    {
      id: 'age',
      type: FieldType.NUMBER,
      label: 'Age',
      inputControl: InputControl.NUMBER,
      validation: { 
        required: true,
        min: 18,
        max: 120
      },
      placeholder: 'Enter your age'
    },
    {
      id: 'newsletter',
      type: FieldType.BOOLEAN,
      label: 'Subscribe to Newsletter',
      inputControl: InputControl.CHECKBOX,
      defaultValue: false
    },
    {
      id: 'country',
      type: FieldType.ENUM,
      label: 'Country',
      inputControl: InputControl.SELECT,
      validation: { required: true },
      dataSource: [
        { key: 'us', value: 'United States' },
        { key: 'ca', value: 'Canada' },
        { key: 'uk', value: 'United Kingdom' },
        { key: 'au', value: 'Australia' },
        { key: 'other', value: 'Other' }
      ]
    },
    {
      id: 'message',
      type: FieldType.STRING,
      label: 'Message',
      inputControl: InputControl.TEXTAREA,
      placeholder: 'Enter your message here...',
      validation: { 
        required: true,
        min: 10,
        max: 500
      }
    }
  ],
  groups: [
    {
      id: 'personal-info',
      label: 'Personal Information',
      collapsible: true,
      defaultCollapsed: false
    },
    {
      id: 'preferences',
      label: 'Preferences',
      collapsible: true,
      defaultCollapsed: true
    }
  ]
};

// Re-export as default for convenience
export default PeakFormEditor;